export default [
    { value: null, text: 'Todos' },
    { value: 'White Label', text: 'On-line' },
    { value: 'TEF', text: 'TEF' },
    { value: 'Transparente', text: 'Transparente' }
]